import { type MD3ShapeName, MD3Shapes, toClipPath } from "../../shapes";

export type NavigationItemShape = "pill" | MD3ShapeName;

/**
 * Returns inline style for a navigation item shape.
 * If shape is 'pill' or 'circle', returns undefined (handled via rounded-full CSS).
 * For custom MD3 shapes (e.g. 'sunny', 'flower', 'star'), returns { clipPath: "path(...)" }.
 */
export function getNavigationShapeStyle(
	shape: NavigationItemShape | undefined,
	width = 56,
	height = 56,
): React.CSSProperties | undefined {
	if (!shape || shape === "pill" || shape === "circle") {
		return undefined;
	}

	const polygon = MD3Shapes[shape];
	if (!polygon) {
		return undefined;
	}

	return {
		clipPath: toClipPath(polygon, width, height),
	};
}

/**
 * Checks if a shape is a 1:1 ratio shape (circle or custom MD3 shape).
 */
export function isSquareShape(shape: NavigationItemShape | undefined): boolean {
	return Boolean(shape && shape !== "pill");
}
